<!-- 最小流量分析 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AreaTreeCard
            ref="areaTreeCard"
            :area-loading="areaLoading"
            :area-tree="areaTree"
            :curr-selected="currSelected"
            @node-selected="handleNodeSelected"
            @node-unselected="handleNodeUnselected"
            @unselect="resetAareaData"
            @collapse-all="collapseTree"
            @area-add="handleAreaAdd"
            @add-child="handleAdd"
            @delete="handleDelete"
            @toggle-visibility="handleTreeToggle"
          />
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('日期')">
                  <a-date-picker
                    v-model="queryParam.date"
                    value-format="YYYY-MM-DD"
                    :placeholder="$t('请选择日期')"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <!-- <a-button type="primary" @click="handleDetail" icon="reload" style="margin-left: 8px">新增</a-button> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
            <template slot="partitionName" slot-scope="text, record">
              <a @click="handleDetail(record)">{{ text }}</a>
            </template>
          </a-table>
        </div>
      </a-card>
    </a-col>
    <MinimumFlowAnalysisModal ref="MinimumFlowAnalysisModalRef" />
  </a-row>
</template>
      
      <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import MinimumFlowAnalysisModal from './modules/MinimumFlowAnalysisModal.vue'
import AreaTreeCard from '../AreaTreeCard.vue'
import axios from 'axios'
export default {
  name: 'MinimumFlowAnalysis',
  mixins: [JeecgListMixin, AreaChoosetMixin, mixinDevice],
  components: {
    JInput,
    MinimumFlowAnalysisModal,
    AreaTreeCard,
  },
  data() {
    return {
      description: '最小流量分析',
      collapsed: false,
      url: {
        list: '/jeecg-gis/area/minFlowRateCompare',
      },
      dataSource1: [

      ],
    }
  },
  created() {},
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('分区名称'),
          align: 'center',
          dataIndex: 'areaName',
          scopedSlots: { customRender: 'partitionName' },
        },
        {
          title: this.$t('物联设备'),
          align: 'center',
          dataIndex: 'deviceId',
        },
        {
          title: this.$t('节点编号'),
          align: 'center',
          dataIndex: 'nodeCode',
        },
        {
          title: this.$t('今日最小瞬时(m³/h)'),
          align: 'center',
          children: [
            {
              title: this.$t('数值'),
              align: 'center',
              dataIndex: 'throughputMnfToday',
            },
            {
              title: this.$t('时间'),
              align: 'center',
              dataIndex: 'recordDate',
            },
          ],
        },
        {
          title: this.$t('昨日最小瞬时(m³/h)'),
          align: 'center',
          children: [
            {
              title: this.$t('数值'),
              align: 'center',
              dataIndex: 'throughputMnfYesterday',
            },
            {
              title: this.$t('时间'),
              align: 'center',
              dataIndex: 'recordDateYestDay',
            },
          ],
        },
        {
          title: this.$t('建议意见'),
          align: 'center',
          dataIndex: 'suggestion',
        },
        {
          title: this.$t('差值(m³/h)'),
          align: 'center',
          dataIndex: 'throughputMnfDaySub',
        },
        // {
        //   title: '上周最小瞬时(m³/h)',
        //   align: 'center',
        //   children: [
        //     {
        //       title: '数值',
        //       align: 'center',
        //       dataIndex: 'lastWeekValue',
        //     },
        //     {
        //       title: '时间',
        //       align: 'center',
        //       dataIndex: 'lastWeekTime',
        //     },
        //   ],
        // },
      ]
    },
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        let params = this.getQueryParams()

        // 添加分页参数
        params.pageNo = this.ipagination.current
        params.pageSize = this.ipagination.pageSize

        // 转换日期参数格式
        if (this.queryParam.date) {
          params.recordDate = this.queryParam.date
        }

        // 添加区域代码参数
        params.areaCode = this.queryParam.areaCode || ''

        const res = await getAction(this.url.list, params)

        if (res.code == 200) {
          // 处理返回的数据，适配到表格
          const result = res.result
          if (result.records) {
            this.dataSource = result.records
            this.ipagination.total = result.total || 0
          } else {
            // 如果没有分页信息，直接使用返回的结果数组
            this.dataSource = Array.isArray(result) ? result : []
            this.ipagination.total = this.dataSource.length
          }
        } else {
          this.dataSource = []
          this.ipagination.total = 0
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      } catch (err) {
        console.log('获取最小流量对比数据失败:', err)
        this.dataSource = []
        this.ipagination.total = 0
        this.$message.error(this.$t('获取数据失败，请稍后重试'))
      } finally {
        this.loading = false
      }
    },
    handleDetail(record) {
      this.$refs.MinimumFlowAnalysisModalRef.edit(record)
      this.$refs.MinimumFlowAnalysisModalRef.disableSubmit = true
    },
  },
}
</script>
      <style scoped>
@import '~@assets/less/common.less';
</style>